module.exports = __webpack_public_path__ + "static/media/app8.ea4495fc.png";